// extracted by mini-css-extract-plugin
module.exports = {"status":"ArtistStatusCell-status-1GN-F TableRowCell-cell-2fbg4","statusIcon":"ArtistStatusCell-statusIcon-3agJe"};